import { Search, Type, Layers } from 'lucide-react';

/**
 * Compact 3-way pill: Dense | Hybrid | BM25
 *   - Dense  = semantic embeddings (OpenAI text-embedding-3-small)
 *   - BM25   = classic lexical / keyword
 *   - Hybrid = Reciprocal Rank Fusion of both (default, recommended)
 */
const MODES = [
  { key: 'dense', label: 'Dense', icon: Layers, hint: 'Semantic embeddings only' },
  { key: 'hybrid', label: 'Hybrid', icon: Search, hint: 'BM25 + dense fused (RRF) — recommended' },
  { key: 'bm25', label: 'BM25', icon: Type, hint: 'Lexical keyword search only' },
];

export default function RetrievalModeToggle({ value = 'hybrid', onChange, size = 'sm', testid = 'retrieval-mode-toggle' }) {
  const padding = size === 'xs' ? 'h-7 px-1.5 text-[10px]' : 'h-8 px-2 text-[11px]';
  return (
    <div className={`inline-flex items-center gap-0.5 rounded-full border border-border bg-background p-0.5`} data-testid={testid}>
      {MODES.map(({ key, label, icon: Icon, hint }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          title={hint}
          className={`${padding} inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-widest transition-all ${
            value === key
              ? 'bg-[#0b1a35] text-white shadow-sm'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted/60'
          }`}
          data-testid={`${testid}-${key}`}
        >
          <Icon className="w-3 h-3" />
          {label}
        </button>
      ))}
    </div>
  );
}
